function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.417 5c.72-1.83 2.5-3.125 4.583-3.125 2.084 0 3.863 1.296 4.584 3.125C8.863 6.83 7.084 8.125 5 8.125 2.917 8.125 1.138 6.829.417 5zm8.258 0C7.988 3.596 6.58 2.708 5 2.708c-1.579 0-2.987.888-3.675 2.292C2.013 6.404 3.421 7.292 5 7.292c1.58 0 2.988-.888 3.675-2.292zM5 3.958c.575 0 1.042.467 1.042 1.042S5.575 6.042 5 6.042 3.96 5.575 3.96 5 4.425 3.958 5 3.958zM3.125 5c0-1.033.842-1.875 1.875-1.875 1.034 0 1.875.842 1.875 1.875S6.034 6.875 5 6.875c-1.033 0-1.875-.842-1.875-1.875z",
  clipRule: "evenodd"
});

var SvgIcVisibility = function SvgIcVisibility(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVisibility, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_visibility.c0e5c41e.svg";
export { ForwardRef as ReactComponent };